import * as yup from 'yup';

const REQUIRED_FIELD = 'Поле обязательно для заполнения';

export const nameRule = yup
  .string()
  .required(REQUIRED_FIELD)
  .matches(/^[a-zA-Z0-9_]+$/, 'Только латинские буквы, цифры и знак _')
  .min(3, 'Минимум 3 символа')
  .max(16, 'Мaксимум 16 символов');

export const passwordRule = yup.string().required(REQUIRED_FIELD);

export const confirmPasswordRule = yup
  .string()
  .required(REQUIRED_FIELD)
  .oneOf([yup.ref('password')], 'Пароли не совпадают.');
